import React from 'react';
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { federalReviewActions } from '_actions';

class FederalReviewListItem extends React.Component {
    render() {
        return (
            <div
                className={
                    this.props.id === this.props.selectedMessage ? messageCenterCommonStyles.selected_message :
                        this.props.message.isRead === true ? messageCenterCommonStyles.read_message : messageCenterCommonStyles.unread_message
                }
                onClick={() => this.props.changeMessage(this.props.id)}>
                {this.props.message.ptname}
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        message: state.entities.federalReviewMsgs[ownprops.id],
        selectedMessage: state.ui.federalReviewMsgs.selectedMessage,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        changeMessage: bindActionCreators(federalReviewActions.changeSelection, dispatch)
    };
}

const connectedFederalReviewListItem = connect(mapStateToProps, mapDispatchToProps)(FederalReviewListItem);
export { connectedFederalReviewListItem as FederalReviewListItem };